import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import { discountCodeBulkIdZodSchema } from "../discount-code-bulk-id";

const discountCodeBulkDeleteCommandZodObject = z.object({
    _id: idZodSchema.default(() =>
        generateId({ prefix: "discount_code_bulk_delete_command__" }),
    ),
    _type: z
        .literal("DISCOUNT_CODE_BULK_DELETE_COMMAND")
        .default("DISCOUNT_CODE_BULK_DELETE_COMMAND"),
    _createdAt: isoAndUnixZodSchema.default(() => nowIsoAndUnix()),
    bulkId: discountCodeBulkIdZodSchema,
    providerId: providerIdZodSchema,
});

type DiscountCodeBulkDeleteCommand = z.infer<
    typeof discountCodeBulkDeleteCommandZodObject
>;

const discountCodeBulkDeleteCommandFactoryParamsZodObject =
    discountCodeBulkDeleteCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });

type FactoryParams = z.infer<
    typeof discountCodeBulkDeleteCommandFactoryParamsZodObject
>;

const discountCodeBulkDeleteCommandFactory = (
    params: FactoryParams,
): DiscountCodeBulkDeleteCommand => {
    return discountCodeBulkDeleteCommandZodObject.parse(params);
};

export {
    discountCodeBulkDeleteCommandFactory,
    discountCodeBulkDeleteCommandFactoryParamsZodObject,
    discountCodeBulkDeleteCommandZodObject,
};
export type {
    DiscountCodeBulkDeleteCommand,
    FactoryParams as DiscountCodeBulkDeleteCommandFactoryParams,
};
